module.exports = __webpack_public_path__ + "static/img/ent-detail-20.0803c0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-20.jpg
// module id = 9LHx
// module chunks = 52